import { useRouter } from 'vue-router';
export function useIdleTimeout(timeout = 5 * 60 * 1000) {
    const router = useRouter();
    let timer = null;

    const resetTimer = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            logoutUser();
        }, timeout);
    };

    const logoutUser = () => {
        router.push('/login'); 
    };

    const events = ['mousemove', 'keydown', 'touchstart', 'scroll'];

    resetTimer();
    events.forEach(event => window.addEventListener(event, resetTimer));

}
